import { render, staticRenderFns } from "./guide.vue?vue&type=template&id=513e349e&scoped=true"
var script = {}
import style0 from "./guide.vue?vue&type=style&index=0&id=513e349e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513e349e",
  null
  
)

export default component.exports